import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import cartService from "../services/cart.service";
import "./PaymentSuccess.css";

const PaymentSuccess = ({ setCartItems }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const finalizeOrder = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const sessionId = params.get("session_id");

        // ✅ ONLINE PAYMENT FLOW
        if (sessionId) {
          await cartService.confirmPayment({ orderId: sessionId });
        }

        // ✅ COD OR ONLINE — always clear frontend cart
        if (setCartItems) setCartItems([]);

        // ✅ Redirect after success
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 2500);

      } catch (err) {
        console.error("Finalize order error:", err);
        navigate("/", { replace: true });
      }
    };

    finalizeOrder();
  }, [location, navigate, setCartItems]);

  return (
    <div className="payment-success-page">
      <div className="success-card">
        <div className="checkmark-circle">
          <div className="checkmark"></div>
        </div>

        <h1>Order Placed Successfully</h1>
        <p>Thank you for shopping with us.</p>
        <span className="redirect-text">
          Redirecting to home page...
        </span>
      </div>
    </div>
  );
};

export default PaymentSuccess;
